<template>
  <div id="app" v-if="showComponent" :class="{ 'desktop-hidden': !desktopView }">
    <div id="adsCarouselWpHolder" :style="inlineStyle" role="region" aria-label="Ads Carousel" aria-live="polite"
      aria-atomic="false">
      <div class="da-container-fluid d-flex flex-column">
        <div class="slideshow-container">
          <div class="bank-carousel-featured-rates-title">
            <div class="bank-carousel-featured-rates-title-badge">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.25753 9.80048C8.25753 7.7531 9.91725 6.09338 11.9646 6.09338C14.012 6.09338 15.6717 7.7531 15.6717 9.80048C15.6717 11.8479 14.012 13.5076 11.9646 13.5076C9.91725 13.5076 8.25753 11.8479 8.25753 9.80048ZM11.9646 7.59338C10.7457 7.59338 9.75753 8.58153 9.75753 9.80048C9.75753 11.0194 10.7457 12.0076 11.9646 12.0076C13.1836 12.0076 14.1717 11.0194 14.1717 9.80048C14.1717 8.58153 13.1836 7.59338 11.9646 7.59338Z"
                  fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.0546 2.3507C11.5701 1.88031 12.3591 1.88031 12.8746 2.3507L14.0397 3.41389L15.6072 3.23858C16.3007 3.16102 16.9391 3.62479 17.0796 4.30833L17.3973 5.8533L18.7685 6.63283C19.3751 6.97772 19.6189 7.72812 19.3309 8.36373L18.6797 9.80035L19.3309 11.237C19.6189 11.8726 19.3751 12.623 18.7685 12.9679L17.3973 13.7474L17.0796 15.2924C16.9711 15.8202 16.5658 16.2169 16.0674 16.3346V20.3298C16.0674 21.4445 14.7674 22.0534 13.9111 21.3398L11.9645 19.7177L10.0179 21.3398C9.1616 22.0534 7.86155 21.4445 7.86155 20.3298V16.3346C7.36333 16.2168 6.95814 15.8201 6.84964 15.2924L6.53199 13.7474L5.1608 12.9679C4.55414 12.623 4.31032 11.8726 4.5984 11.237L5.24952 9.80035L4.5984 8.36373C4.31032 7.72813 4.55414 6.97772 5.1608 6.63283L6.53199 5.8533L6.84964 4.30834C6.99018 3.62479 7.62852 3.16102 8.32203 3.23858L9.88955 3.41389L11.0546 2.3507ZM9.36155 16.2459V19.9342L11.1228 18.4665C11.6104 18.0602 12.3186 18.0602 12.8061 18.4665L14.5674 19.9342V16.2458L14.0397 16.1868L12.8746 17.25C12.3591 17.7204 11.5701 17.7204 11.0546 17.25L9.88955 16.1868L9.36155 16.2459ZM11.9646 3.55098L10.8504 4.56773C10.5632 4.82985 10.1768 4.95538 9.79039 4.91216L8.29134 4.7445L7.98756 6.22198C7.90925 6.60289 7.67048 6.93152 7.33242 7.12371L6.02113 7.86919L6.64381 9.24305C6.80434 9.59724 6.80434 10.0035 6.64381 10.3576L6.02113 11.7315L7.33242 12.477C7.67048 12.6692 7.90925 12.9978 7.98756 13.3787L8.29134 14.8562L9.79039 14.6885C10.1768 14.6453 10.5632 14.7708 10.8504 15.033L11.9646 16.0497L13.0788 15.033C13.3661 14.7708 13.7524 14.6453 14.1389 14.6885L15.6379 14.8562L15.9417 13.3787C16.02 12.9978 16.2588 12.6692 16.5968 12.477L17.9081 11.7315L17.2855 10.3576C17.1249 10.0035 17.1249 9.59724 17.2855 9.24305L17.9081 7.86918L16.5968 7.12371C16.2588 6.93152 16.02 6.60289 15.9417 6.22198L15.6379 4.7445L14.1389 4.91216C13.7524 4.95538 13.3661 4.82985 13.0788 4.56773L11.9646 3.55098Z"
                  fill="white" />
              </svg>
            </div>
            <div class="bank-carousel-featured-rates-title-text">TODAY'S FEATURED RATES</div>
          </div>
          <div class="carouselWbuttons" :id="zoneKey">
            <div class="carousel-container" ref="carouselContainer" @scroll="handleScroll" role="list"
              aria-label="Carousel Slides">
              <item v-if="isLoaded" v-for="(placement, index) in placements" :key="placement.id + '-' + index"
                :index="index" :model="placement" :zoneKey="zoneKey" :ratingsData="localRatingsData"
                :slideCount="placements.length" :cardWidth="cardWidth">
              </item>
              <loader v-else></loader>
            </div>
            <div class="carouselNav-container" v-if="isLoaded && placements.length > 0">
              <div v-if="placements.length > 3" class="navigation desktop-tablet-only">
                <a class="prev-button prev" @click="prevButtonClick" aria-label="Prev Slide" role="button" tabindex="0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path d="M15.6255 19.25L8.38113 12.0039C8.37722 12 8.37722 11.9937 8.38113 11.9898L15.6259 4.75"
                      stroke="#0069BA" stroke-width="3.5" stroke-linecap="round" />
                  </svg>
                </a>
                <a class="next-button next" @click="nextButtonClick" aria-label="Next Slide" role="button" tabindex="0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path
                      d="M8.37443 19.2627L15.6188 12.004C15.6227 12.0001 15.6227 11.9937 15.6188 11.9898L8.37401 4.73748"
                      stroke="#0069BA" stroke-width="3.5" stroke-linecap="round" />
                  </svg>
                </a>
              </div>
              <div v-if="placements.length > 1" class="navigation mobile-only">
                <a class="prev-button prev" @click="prevButtonClick" aria-label="Prev Slide" role="button" tabindex="0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path d="M15.6255 19.25L8.38113 12.0039C8.37722 12 8.37722 11.9937 8.38113 11.9898L15.6259 4.75"
                      stroke="#0069BA" stroke-width="3.5" stroke-linecap="round" />
                  </svg>
                </a>
                <a class="next-button next" @click="nextButtonClick" aria-label="Next Slide" role="button" tabindex="0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path
                      d="M8.37443 19.2627L15.6188 12.004C15.6227 12.0001 15.6227 11.9937 15.6188 11.9898L8.37401 4.73748"
                      stroke="#0069BA" stroke-width="3.5" stroke-linecap="round" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import item from './item.vue';
import loader from './loader.vue';
import apiClient from '../../services/apiClient';
import analytics from "../../services/analytics";
import { AdPlacement, RatingData, AdZone } from '../../common/adModels';


export default defineComponent({
  name: 'App',
  components: {
    item,
    loader
  },
  props: {
    zoneKey: {
      type: String,
      default: ""
    },
    ratingsData: {
      type: Array as PropType<RatingData[]>,
      required: false,
      default: () => []
    },
    desktopView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      placements: [] as AdPlacement[],
      isLoaded: false,
      inlineStyle: 'font-size:14px; font-family:Lato, sans-serif',
      pageCount: 1,
      desktopCounter: 0,
      autoScrollInterval: null as number | null,
      defaultScrollDelay: 15000,
      mobileCounter: 0,
      isMobile: false,
      userAgent: navigator.userAgent,
      localRatingsData: [] as RatingData[],
      isScrollingBack: false,
      debounceTimer: null as number | null,
      cardsToShow: 3.5,
      cardWidth: 0,
      carouselContainerWidth: 0,
      showComponent: true,
      mobileCardsToShow: 2
    };
  },
  computed: {
    placementsCount(): number {
      return this.placements.length;
    },
    dateStr(): string {
      const today = new Date();
      return today.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    },
    modelLength(): boolean {
      if (Array.isArray(this.placements)) {
        return this.placements.length > 1;
      } else if (typeof this.placements === 'object' && this.placements !== null) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.loadApiResult();
  },
  mounted() {
    this.calculateCardWidth();
    this.resetAutoScroll(this.defaultScrollDelay);
    window.addEventListener('resize', this.calculateCardWidth);
  },
  unmounted() {
    this.stopAutoScroll();
    window.removeEventListener('resize', this.calculateCardWidth);
  },
  methods: {
    async loadApiResult() {
      try {
        this.isLoaded = false;
        const fetchedData: any[] = await apiClient.getAdZones([this.zoneKey]);
        const bankIdsSet = new Set<number>();
        fetchedData.forEach(zone => {
          zone.placements.forEach(placement => {
            bankIdsSet.add(placement.account.bankId);
          });
        });
        const bankIds = Array.from(bankIdsSet);

        if (bankIds.length === 0) {
          this.placements = [];
          this.isLoaded = true;
          this.showComponent = false;
          return;
        } else {
          if (!this.ratingsData || this.ratingsData.length === 0) {
            const bankRatings = await apiClient.getBankRatings(Array.from(bankIdsSet));
            this.localRatingsData = bankRatings;
          } else {
            this.localRatingsData = this.ratingsData;
          }
        }
        if (fetchedData && fetchedData.length > 0) {
          const matchedZone = fetchedData.find((zone: any) => zone.keyName === this.zoneKey);

          if (matchedZone) {
            this.placements = matchedZone.placements;
            analytics.trackAdImpressions(this.zoneKey, this.placements);
          } else {
            console.warn(`No zone found matching zoneKey: ${this.zoneKey}`);
            this.placements = [];
          }
        } else {
          console.warn(`No zones found for zoneKey: ${this.zoneKey}`);
          this.placements = [];
        }

        this.isLoaded = true;
        if (this.placements.length === 0) {
          this.showComponent = false;
        } else {
          this.showComponent = true;
        }
      } catch (error) {
        console.error('Error fetching ad zones or bank ratings:', error);
        this.placements = [];
        this.isLoaded = true;
        this.showComponent = false;
      }
    },
    handleScroll() {
      if (!this.$refs.carouselContainer) return;
      this.updateMobileCounterFromScroll();
    },
    prevButtonClick() {
      this.scrollByCard('prev');
      this.resetAutoScroll(this.defaultScrollDelay);
    },
    nextButtonClick() {
      this.scrollByCard('next');
      this.resetAutoScroll(this.defaultScrollDelay);
    },
    scrollByCard(direction: 'prev' | 'next') {
      if (!this.$refs.carouselContainer) return;

      const carouselContainer = this.$refs.carouselContainer as HTMLElement;
      const scrollAmount = this.cardWidth;
      const maxScrollLeft = carouselContainer.scrollWidth - this.carouselContainerWidth;
      const currentScrollLeft = carouselContainer.scrollLeft;
      const screenWidth = window.innerWidth;

      if (screenWidth >= 769) {
        if (direction === "next") {
          // If we are at the end, scroll to the beginning
          if (currentScrollLeft >= maxScrollLeft - 1) {
            carouselContainer.scrollTo({ left: 0, behavior: "smooth" });
          }
          // Else go to next scrollable card
          else {
            const newScrollLeft = Math.min(currentScrollLeft + scrollAmount, maxScrollLeft);
            carouselContainer.scrollTo({ left: newScrollLeft, behavior: "smooth" });
          }
        } else {
          // If we are at the beginning scroll to the end
          if (currentScrollLeft <= 0) {
            carouselContainer.scrollTo({ left: maxScrollLeft, behavior: "smooth" });
          }
          // Else go to previous scrollable card
          else {
            const newScrollLeft = Math.max(currentScrollLeft - scrollAmount, 0);
            carouselContainer.scrollTo({ left: newScrollLeft, behavior: "smooth" });
          }
        }
      } else {
        const scrollAmount = this.cardWidth;

        if (direction === 'next') {
          // If we are at (or very near) the end, scroll to the beginning
          if (currentScrollLeft >= maxScrollLeft - 1) {
            carouselContainer.scrollTo({ left: 0, behavior: "smooth" });
          } else {
            // Else go to next scrollable card
            const newScrollLeft = Math.min(currentScrollLeft + scrollAmount, maxScrollLeft);
            carouselContainer.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
          }
        } else {
          // If we are at the beginning scroll to the end
          if (currentScrollLeft <= 0) {
            carouselContainer.scrollTo({ left: maxScrollLeft, behavior: "smooth" });
          } else {
            // Else go to previous scrollable card
            const newScrollLeft = Math.max(currentScrollLeft - scrollAmount, 0);
            carouselContainer.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
          }

        }
      }
      this.updateMobileCounterFromScroll();
    },
    scrollNext() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(() => {
        if (!this.$refs.carouselContainer) {
          console.log("carouselContainer not found");
          return;
        }

        const carouselContainer = this.$refs.carouselContainer as HTMLElement;
        const scrollAmount = this.cardWidth;
        const maxScrollLeft = carouselContainer.scrollWidth - this.carouselContainerWidth;

        if (carouselContainer.scrollLeft >= maxScrollLeft - 1) {
          carouselContainer.scrollTo({ left: 0, behavior: "smooth" }); // Loop to start
        } else {
          // Scroll by one "card" width
          const nextScrollLeft = Math.min(carouselContainer.scrollLeft + scrollAmount, maxScrollLeft);
          carouselContainer.scrollTo({ left: nextScrollLeft, behavior: "smooth" });
        }

        this.updateMobileCounterFromScroll();
      }, 200); // Debounce time set to 200ms
    },
    stopAutoScroll() {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    },
    resetAutoScroll(delay: number) {
      this.stopAutoScroll();
      const self = this;
      this.autoScrollInterval = setInterval(function () {
        self.scrollNext();
      }, delay);
      if (this.isScrollingBack) {
        this.scrollNext();
      }
    },
    updateMobileCounterFromScroll() {
      if (!this.$refs.carouselContainer) return;
      const carouselContainer = this.$refs.carouselContainer as HTMLElement;
      const newMobileCounter = Math.round(carouselContainer.scrollLeft / this.cardWidth);
      if (newMobileCounter !== this.mobileCounter) {
        this.mobileCounter = newMobileCounter;
      }
    },
    calculateCardWidth() {
      if (!this.$refs.carouselContainer) return;
      const carouselContainer = this.$refs.carouselContainer as HTMLElement;
      this.carouselContainerWidth = carouselContainer.offsetWidth;

      if (window.innerWidth > 768) {
        this.cardWidth = this.carouselContainerWidth / this.cardsToShow;
      } else {
        this.cardWidth = this.carouselContainerWidth / this.mobileCardsToShow;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.slideshow-container {
  max-width: 990px;
  position: relative;
  margin: auto;
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  background: #f1f8ff;
  font-family: Lato, sans-serif;
}

.bank-carousel-featured-rates-title {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: var(--radius-0, 0px) var(--radius-0, 0px) 8px var(--radius-0, 0px);
  border: 1px solid #101f30;
  background: var(--Blue-Variants-lt-blue-lighten-4, #f1f8ff);
  width: 255px;
  margin-bottom: 15px;
  margin-top: 3px;
}

.bank-carousel-featured-rates-title-text {
  color: var(--Variants-lt-blue-darken-3, var(--Blue-Variants-lt-blue-darken-2, #002a4a));
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.25px;
  text-transform: uppercase;
}

.bank-carousel-featured-rates-title-badge {
  display: flex;
  padding: 6px 8px;
  align-items: flex-start;
  gap: 8px;
  background: var(--Blue-Variants-lt-blue-darken-2, #002a4a);
}

.carousel-container {
  display: flex;
  overflow-x: auto;
  gap: 5px;
  scroll-snap-type: x mandatory;
  max-width: 100%;
  margin: auto;
  position: relative;
  background-color: #F1F8FF;
  scroll-behavior: smooth;
  scroll-padding-left: 35px;

  @media (min-width: 768px) and (max-width: 1023px) {
    scroll-padding-left: 74px;
  }

  @media (min-width: 820px) and (max-width: 1180px) {
    scroll-padding-left: 50px;
  }

  @media (min-width: 1024) and (max-width: 1365) {
    scroll-padding-left: 64px;
  }

  @media (min-width: 1024px) {
    scroll-padding-left: 66px;
  }
}

@media (min-width: 769px) {
  .carousel-container {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    max-width: 100%;
    margin: auto;
    position: relative;
    background-color: #F1F8FF;
    scroll-behavior: smooth;
  }
}

.carousel-container::-webkit-scrollbar {
  display: none;
}

.carouselNav-container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
  background-color: #F1F8FF;
}

.bank-carousel-desktop {
  display: none;
}

.bank-carousel-mobile {
  display: flex;
  margin-bottom: 8px;
  justify-content: center;
}

@media (max-width: 575px) {
  .bank-carousel-mobile {
    display: flex;
  }

  .bank-carousel-desktop {
    display: none;
  }

}

@media (min-width: 576px) {
  .bank-carousel-mobile {
    display: flex;
  }

  .bank-carousel-desktop {
    display: none;
  }
}

@media (min-width: 576px) and (max-width: 768px) {
  .bank-carousel-mobile {
    display: flex;
  }

  .bank-carousel-desktop {
    display: none;
  }
}

@media (min-width: 576px) and (max-width: 991px) {}

@media (min-width: 992px) {}

.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 52%;
  color: white;
  font-weight: bold;
  transition: 0.6s ease;
  user-select: none;
}

.next {
  right: -20px;
}

.prev {
  left: -19px;
}

@media only screen and (max-width: 300px) {

  .prev,
  .next,
  .text {
    font-size: 11px;
  }
}

.prev-button,
.next-button {
  width: fit-content;
  cursor: pointer;
  outline: none;
}

.carouselWbuttons {
  display: block;
  width: 100%;
  height: auto;
  gap: 10px;
}

.desktop-tablet-only {
  display: none;
}

.mobile-only {
  display: none;
}

@media (min-width: 769px) {
  .desktop-tablet-only {
    display: flex;
  }
}

@media (max-width: 768px) {
  .mobile-only {
    display: flex;
  }
}

@media (min-width: 992px) {
  .desktop-hidden {
    display: none;
  }
}
</style>